import { faLayerGroup } from "@fortawesome/sharp-light-svg-icons";
import type { ReactNode } from "react";
import { useAppSelector } from "../../../../hooks";
import { CustomSwitch } from "../../../../ui/CustomSwitch";
import { useMapFilters } from "../../hooks/mapDataAndFilters";
import { ToolBarDropdown } from "../../ui/MapControlsV2";
import { MenuCategory } from "../../ui/Menu";
import { HeatmapControls } from "./HeatmapControls";

interface LayersControlProps {
    className?: string;
}

interface SectionRowProps {
    label: string;
    checked: boolean;
    onChange: (v: boolean) => void;
    disabled?: boolean;
}

const SectionRow = ({
    label,
    checked,
    onChange,
    disabled,
}: SectionRowProps) => (
    <div className="flex items-center justify-between gap-3 px-1 py-1 rounded hover:bg-ae-gray-100/70">
        <span className="text-gray-700 select-none">{label}</span>
        <CustomSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            size="xs"
        />
    </div>
);

interface SectionProps {
    title: string;
    children: ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
    <div className="px-1 py-1.5 space-y-1">
        <MenuCategory className="px-1">{title}</MenuCategory>
        <div className="space-y-0.5">{children}</div>
    </div>
);

export const LayersControl = (props: LayersControlProps) => {
    const { filterState, updateMapFilterState } = useMapFilters("mainMap");
    const heatmapsEnabled = useAppSelector((s) =>
        s.auth.flags.includes("enable_experimental_heatmaps"),
    );
    return (
        <ToolBarDropdown
            enabled={true}
            icon={faLayerGroup}
            label="Extra"
            className={props.className}
        >
            <div className="w-64 text-sm divide-y divide-ae-gray-100">
                {heatmapsEnabled && (
                    <Section title="Heatmaps">
                        <SectionRow
                            label="Emission intensity"
                            checked={
                                filterState.analytics.emissionHeatmaps.enabled
                            }
                            onChange={(val) =>
                                updateMapFilterState((d) => {
                                    d.analytics.emissionHeatmaps.enabled = val;
                                })
                            }
                        />
                        {filterState.analytics.emissionHeatmaps.enabled && (
                            <HeatmapControls />
                        )}
                    </Section>
                )}

                <Section title="Satellite coverage">
                    <SectionRow
                        label="Show coverage"
                        checked={false}
                        onChange={() => null}
                        disabled={true}
                    />
                </Section>
            </div>
        </ToolBarDropdown>
    );
};
